<template>
  <div class="container">
    <el-row class="common-box">
      <div class="common-search">
        <el-form ref="formData" :model="formData" :inline="true" label-width="70px" class="formInline" size="mini">
          <el-form-item label="项目编号">
            <el-input v-model="formData.projectCode" placeholder="请输入项目编号..."></el-input>
          </el-form-item>
          <el-form-item label="项目名称">
            <el-input v-model="formData.projectName" placeholder="请输入项目名称..."></el-input>
          </el-form-item>
          <el-form-item label="行业标签">
            <el-select v-model="formData.categoryStatus" placeholder="请选择行业标签">
              <el-option label="不限" :value="null"></el-option>
              <el-option label="已绑定" value="1"></el-option>
              <el-option label="未绑定" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="岗位标签">
            <el-select v-model="formData.postStatus" placeholder="请选择岗位标签">
              <el-option label="不限" :value="null"></el-option>
              <el-option label="已绑定" value="1"></el-option>
              <el-option label="未绑定" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="search-btn" @click="getData">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="common-box-body" style="padding-top: 0;">
        <el-table :data="tableData" ref="tableData" size="small" class="table-expand" v-loading="listLoading"
                  element-loading-text="拼命加载中" border style="width: 100%">
          <el-table-column prop="crmProject.projectCode" label="项目编号" min-width="200" align="center"></el-table-column>
          <el-table-column prop="crmProject.projectName" label="项目名称" min-width="360" align="center"></el-table-column>
          <el-table-column prop="crmProject.startTime" label="项目开始时间" width="150" align="center"
                           :formatter="formatDate"></el-table-column>
          <el-table-column prop="crmProject.endTime" label="项目结束时间" width="150" align="center"
                           :formatter="formatDate"></el-table-column>
          <el-table-column prop="crmProject.projCode" label="行业标签" min-width="150" align="center">
            <template slot-scope="scope">
              <span>
                <span v-for="item in scope.row.crmSignLst" :key="item.id"
                      v-if="item.signType==1">{{item.signName}}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="crmProject.projCode" label="岗位标签" min-width="120" align="center">
            <template slot-scope="scope">
              <span>
                <span v-for="item in scope.row.crmSignLst" :key="item.id"
                      v-if="item.signType==2">{{item.signName}}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" :disabled="auths.indexOf(2) < 0" @click="toggleExpansion(scope.row)">
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination table-pagination"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="formData.pageNo"
                       :page-sizes="[10, 20, 30, 40]"
                       :page-size="formData.pageSize"
                       layout="slot, total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </el-row>

    <el-dialog class="quitDialog dialog" title="提 示" :visible.sync="confirmDialog" width="30%" center>
      <div class="dialog-body"><img src="../../common/images/icon-question.png" alt="">确认清除绑定吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmDialog = false" type="text" size="small">取 消</el-button>
        <el-button class="dialog-btn" size="small" @click="updateProjectSign(editRowObj, 'clear')">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog class="limitPage" title="编辑" :visible.sync="editRowDialog" width="780px" :center="true"
               :show-close="false">
      <el-form inline v-model="editRowObj" size="mini" style="margin: 20px 30px 0 30px" class="formInline">
        <el-row>
          <el-form-item label="项目编号：">
            <span>{{ editRowObj.crmProject.projectCode }}</span>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="项目名称：">
            <span>{{ editRowObj.crmProject.projectName }}</span>
          </el-form-item>
        </el-row>
        <el-form-item label="行业标签：">
          <el-cascader v-model="editRowObj.categoryIdLst" placeholder="请选择行业标签" :options="signList"
                       change-on-select></el-cascader>
        </el-form-item>
        <el-form-item label="岗位标签：">
          <el-select v-model="editRowObj.postIdLst" clearable placeholder="请选择岗位标签">
            <el-option
                v-for="item in postList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" round class="clear-btn" @click="confirmDialog = true">清除绑定
          </el-button>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editRowDialog = false" type="text" size="small">取 消</el-button>
        <el-button class="dialog-btn" size="small" @click="updateProjectSign(editRowObj, 'edit')"
                   :loading="ACKButtonLoading">确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  //韩金辰180705优化重写
  import utils from '../../common/js/util'
  import moment from 'moment'

  export default {
    name: "projLabelConfig",
    data() {
      return {
        auths: [],// 页面内权限
        //筛选项及table数据
        formData: {
          projectId: null,
          projectCode: '',
          projectName: '',
          categoryStatus: '',
          postStatus: '',
          categoryId: null,
          postId: null,
          pageNo: 1,
          pageSize: 10
        },
        total: null,
        tableData: [],
        tableDataLoading: false,
        listDataLoading: true,
        /*
        弹窗相关数据
        */
        signList: [],//行业标签基础数据
        postList: [],//岗位标签基础数据
        ACKButtonLoading: false,//编辑弹窗的确认按钮是否不可用
        confirmDialog: false,
        editRowDialog: false,
        //弹窗数据
        editRowObj: {
          crmProject: {
            projectCode: null,
            projectName: null,
          },
          categoryIdLst: null,
          postIdLst: null
        },
      }
    },
    computed: {
      listLoading() {
        return Boolean(this.tableDataLoading || this.listDataLoading)
      },
    },
    mounted() {
      this.getData()
      this.getAuth()
      this.getLabalList()
    },
    methods: {
      //工具类-转换时间格式
      formatDate(row, column, cellValue) {
        if (cellValue) {
          return moment(cellValue).format('YYYY-MM-DD')
        } else {
          return ''
        }
      },
      //获取页面权限
      getAuth() {
        this.$http({
          method: "GET",
          url: "/rest/sysUser/getSysUserWebAuth",
          params: {
            webId: 10,
            sysUserId: sessionStorage.getItem("sysUserId")
          }
        }).then(res => {
          res.data.map(item => {
            this.auths.push(item.auth)
          })
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '权限获取失败，请稍后重试')
        })
      },
      /*
      table相关
      */
      //获取数据并赋给tableData中
      getData() {
        this.tableDataLoading = true
        this.$http({
          method: "GET",
          url: '/rest/projectSign/projectSignConfig',
          params: this.formData
        }).then(res => {
          //搜索时没有权限，进行提示
          if (res.data.status == 460) {
            utils.myNotify(this, 'error', res, '查询失败，请稍后重试')
          } else {
            this.tableData = res.data
          }
          this.tableDataLoading = false
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
          this.tableDataLoading = false
        })
        //获取搜索到的总条数
        this.$http({
          method: "GET",
          url: '/rest/projectSign/searchCountProjectSignConfig',
          params: this.formData
        }).then(res => {
          this.total = res.data
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      handleSizeChange(val) {
        this.formData.pageSize = val
        this.getData()
      },
      handleCurrentChange(val) {
        this.formData.pageNo = val
        this.getData()
      },
      //编辑本行数据
      toggleExpansion(row, handle) {
        this.editRowDialog = true;
        row.postIdLst = row.postIdLst[0] ? row.postIdLst[0] : null//后端返回的格式不对，在这转换一下
        this.editRowObj = JSON.parse(JSON.stringify(row))
      },
      /*
      编辑弹窗相关
      */
      //获取标签列表的基础数据
      getLabalList() {
        // 获取行业标签，按级别保存在signList中，随后删除没有children值的children属性
        this.$http({
          method: "GET",
          url: '/rest/projectSign/getSignLst',
          params: {
            signType: 1
          }
        }).then(res => {
          let data = [] //把所有的空集都删掉
          let maxLevel = 1;//每个数组中的级别肯定是一样的，所以只要有长度，就取他第一位的级别，记录其最大值
          res.data.map(item => {
            if (item.length) {
              data.push(item)
              if (item[0].signLevel > maxLevel) {
                maxLevel = item[0].signLevel
              }
            }
          })
          //记录所有的level
          let everyLevel = []
          for (let i = 0; i < maxLevel; i++) {
            everyLevel.push([])
          }
          data.map(item => {
            item.map(item1 => {
              everyLevel[item1.signLevel - 1].push({
                value: item1.id,
                label: item1.signName,
                pid: item1.pid,
                children: []
              })
            })
          })
          //为所有的子集找爸爸，必须是倒着来for
          for (let i = maxLevel - 1; i > 0; i--) {
            everyLevel[i].map(item1 => {
              everyLevel[i - 1].map(item2 => {
                if (item2.value == item1.pid) {
                  item2.children.push(item1)
                }
              })
            })
          }
          //最后把所有的空children数组删掉，然后赋值给list
          this.clearEmpty(everyLevel[0])
          this.signList = everyLevel[0]
          this.listDataLoading = false
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
          this.listDataLoading = false
        })

        // 岗位标签，获取后按级别追加到postList
        this.$http({
          method: "GET",
          url: '/rest/projectSign/getSignLst',
          params: {
            signType: 2
          }
        }).then(res => {
          let data = res.data
          data[0].map(item => {
            if (item.signName != '不限') {
              this.postList.push({
                value: item.id,
                label: item.signName,
              })
            }
          })
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      //type 区分是编辑还是清空，row其实不用传，无所谓了
      //如果是清除绑定，则先清除，然后再以当前数据执行一次编辑-确认
      updateProjectSign(row, type) {
        if (type == 'clear') {
          this.editRowObj.categoryIdLst = [];
          this.editRowObj.postIdLst = null;
          this.confirmDialog = false;
          this.updateProjectSign(this.editRowObj, 'edit')
        } else {
          this.ACKButtonLoading = true;
          this.$http({
            method: 'POST',
            url: '/rest/projectSign/updateProjectSign',
            data: {
              projectId: row.crmProject.id,
              categoryId: row.categoryIdLst[row.categoryIdLst.length - 1] || null,//插件必须读数组，而更新时候只要传里面最后一个孩子的id即可
              postId: row.postIdLst,
            }
          }).then(res => {
            utils.myNotify(this, 'success', res, '操作成功')
            this.getData()
            this.editRowDialog = false
            this.ACKButtonLoading = false;
          }).catch(err => {
            utils.myNotify(this, 'error', err.response, '操作失败，请稍后重试')
            this.ACKButtonLoading = false;
          })
        }
      },
      //去除空的children（此弹窗专用的工具函数）
      clearEmpty(arr) {
        arr.map(item => {
          if (item.children.length == 0) {
            delete item.children
          } else {
            this.clearEmpty(item.children)
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .search-btn {
    margin-left: 25px;
  }
</style>




// WEBPACK FOOTER //
// src/views/labelSystem/projLabelConfig.vue